import { BANK_STATEMENT_ANALYSER_ACTIONS, CASE_DETAILS_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants";
import { Map, List } from "immutable";
import moment from "moment";

const INITIAL_STATE = new Map({});
const DEFAULT_DATA = new Map({
    createJob: new Map({
        status: null,
        data: null,
        error: null
    }),
    jobList: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: new List([]),
        error: null
    }),
    jobDetails: new Map({}),
    statementAnalysis: new Map({})
});

export default (state = INITIAL_STATE, { type, payload, error }) => {
    switch(type) {
    case CASE_DETAILS_ACTIONS.FETCH_CASE_DETAILS:
        return state.set(payload.caseId, DEFAULT_DATA);
    case BANK_STATEMENT_ANALYSER_ACTIONS.CREATE_ANALYSER_REQUEST:
        return state
            .setIn([payload.caseId, "createJob", "status"], STATE_STATUS.CREATING)
            .setIn([payload.caseId, "createJob", "data"], payload.requestData);
    case BANK_STATEMENT_ANALYSER_ACTIONS.CREATED_ANALYSER_REQUEST:
        return state
            .setIn([payload.caseId,"createJob", "status"], STATE_STATUS.CREATED);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_CREATE_ANALYSER_REQUEST:
        return state
            .setIn([payload.caseId, "createJob", "status"], STATE_STATUS.CREATE_FAILED)
            .setIn([payload.caseId, "createJob", "error"], error);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_ANALYSER_JOBS:
        return state
            .setIn([payload.caseId, "jobList", "status"], STATE_STATUS.FETCHING);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_ANALYSER_JOBS:
        return state
            .setIn([payload.caseId, "jobList", "status"], STATE_STATUS.FETCHED)
            .setIn([payload.caseId, "jobList", "data"], payload.data && payload.data.results && new List(payload.data.results.map(_ => {
                _.create_date = moment(_.create_date);
                return _;
            })))
            .setIn([payload.caseId, "jobList", "count"], payload.data && payload.data.count);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_ANALYSER_JOBS:
        return state
            .setIn([payload.caseId, "jobList", "status"], STATE_STATUS.FETCH_FAILED)
            .setIn([payload.caseId, "jobList", "error"], error);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_REQUEST_DETAILS:
        return state
            .setIn([payload.caseId, "jobDetails", payload.jobId, "status"], STATE_STATUS.FETCHING);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_REQUEST_DETAILS:
        return state
            .setIn([payload.caseId, "jobDetails", payload.jobId, "status"], STATE_STATUS.FETCHED)
            .setIn([payload.caseId, "jobDetails", payload.jobId, "data"], payload.data);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_REQUEST_DETAILS:
        return state
            .setIn([payload.caseId, "jobDetails", payload.jobId, "status"], STATE_STATUS.FETCH_FAILED);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCH_STATEMENT_ANALYSIS:
        return state
            .setIn([payload.caseId, "statementAnalysis", payload.requestId, "status"], STATE_STATUS.FETCHING);
    case BANK_STATEMENT_ANALYSER_ACTIONS.FETCHED_STATEMENT_ANALYSIS:
        // eslint-disable-next-line no-case-declarations
        let jobList = state.getIn([payload.caseId, "jobList", "data"]);
        return state
            .setIn([payload.caseId, "statementAnalysis", payload.requestId, "status"], STATE_STATUS.FETCHED)
            .setIn([payload.caseId, "statementAnalysis", payload.requestId, "data"], payload.data)
            .setIn([payload.caseId, "jobList", "data"], jobList.map(_ => {
                let row = _;
                if(_.analysis_request == payload.requestId) {
                    row.using = true;
                } else {
                    row.using = false;
                }
                return row;
            }));
    case BANK_STATEMENT_ANALYSER_ACTIONS.FAILED_FETCH_STATEMENT_ANALYSIS:
        return state
            .setIn([payload.caseId, "statementAnalysis", payload.requestId, "status"], STATE_STATUS.FETCH_FAILED)
            .setIn([payload.caseId, "statementAnalysis", payload.requestId, "error"], error);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};